<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Link({
              label: 'Button link',
              modelPath: [this, 'form', 'button_link'],
              required: true
            }),
            new fields.Switch({
              label: 'Is secondary',
              modelPath: [this, 'form', 'is_secondary']
            })
          ]
        }
      ]
    }
  }
}
</script>
